import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';

const AllClients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filter states
  const [searchQuery, setSearchQuery] = useState('');
  const [filterReservationType, setFilterReservationType] = useState('All');
  const [filterStudentAccepted, setFilterStudentAccepted] = useState('All');
  const [filterAuditionPaid, setFilterAuditionPaid] = useState('All');

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const snap = await getDocs(collection(db, 'reservations'));
        setClients(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error("Error fetching clients:", e);
      }
      setLoading(false);
    };
    fetchClients();
  }, []);

  const updateLocal = (id, field, value) =>
    setClients(clients.map(c => c.id === id ? { ...c, [field]: value } : c));

  const handleAccept = async id => {
    await updateDoc(doc(db, 'reservations', id), { studentAccepted: true });
    updateLocal(id, 'studentAccepted', true);
  };
  const handleDeny = async id => {
    await updateDoc(doc(db, 'reservations', id), { studentAccepted: false });
    updateLocal(id, 'studentAccepted', false);
  };
  const handleMarkPaid = async id => {
    await updateDoc(doc(db, 'reservations', id), { auditionPaid: true });
    updateLocal(id, 'auditionPaid', true);
  };

  const filtered = clients.filter(c => {
    const name = `${c.participant?.firstName || ''} ${c.participant?.lastName || ''}`.toLowerCase();
    const matchesSearch = name.includes(searchQuery.toLowerCase());
    const matchesResType = filterReservationType === 'All'
      || c.reservationType === filterReservationType;
    const matchesAccepted = filterStudentAccepted === 'All'
      || (filterStudentAccepted === 'Accepted' && c.studentAccepted)
      || (filterStudentAccepted === 'Not Accepted' && !c.studentAccepted);
    const matchesPaid = filterAuditionPaid === 'All'
      || (filterAuditionPaid === 'Paid' && c.auditionPaid)
      || (filterAuditionPaid === 'Not Paid' && !c.auditionPaid);
    return matchesSearch && matchesResType && matchesAccepted && matchesPaid;
  });

  if (loading) return <div>Loading clients...</div>;

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">All Clients</h1>

      <div className="mb-6 space-y-4">
        <input
          type="text"
          placeholder="Search by name..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          className="w-full p-2 border rounded bg-gray-50 text-gray-900"
        />
        <div className="flex flex-wrap gap-4">
          <select
            value={filterReservationType}
            onChange={e => setFilterReservationType(e.target.value)}
            className="p-2 border rounded bg-gray-50 text-gray-900"
          >
            <option value="All">All Reservation Types</option>
            <option value="single">Single</option>
            <option value="group">Group</option>
          </select>
          <select
            value={filterStudentAccepted}
            onChange={e => setFilterStudentAccepted(e.target.value)}
            className="p-2 border rounded bg-gray-50 text-gray-900"
          >
            <option value="All">All Statuses</option>
            <option value="Accepted">Accepted</option>
            <option value="Not Accepted">Not Accepted</option>
          </select>
          <select
            value={filterAuditionPaid}
            onChange={e => setFilterAuditionPaid(e.target.value)}
            className="p-2 border rounded bg-gray-50 text-gray-900"
          >
            <option value="All">All Payment Statuses</option>
            <option value="Paid">Paid</option>
            <option value="Not Paid">Not Paid</option>
          </select>
        </div>
      </div>

      {filtered.length === 0 ? (
        <p>No clients found.</p>
      ) : (
        <ul className="space-y-4">
          {filtered.map(c => (
            <li key={c.id} className="p-4 border rounded shadow">
              <p><strong>ID:</strong> {c.id}</p>
              <p><strong>Account Type:</strong> {c.accountType}</p>
              <p><strong>Name:</strong> {c.participant?.firstName} {c.participant?.lastName}</p>
              <p><strong>Email:</strong> {c.participant?.email}</p>
              <p><strong>Instrument:</strong> {c.participant?.instrument}</p>
              <p><strong>Reservation Type:</strong> {c.reservationType}</p>
              <p><strong>Initial Payment:</strong> {c.initialPayment ? 'Yes' : 'No'}</p>
              <p><strong>Student Accepted:</strong> {c.studentAccepted ? 'Yes' : 'No'}</p>
              <p><strong>Audition Paid:</strong> {c.auditionPaid ? 'Yes' : 'No'}</p>
              <p><strong>Is Parent?</strong> {c.role === 'parent' ? 'Yes' : 'No'}</p>
              <div className="flex gap-4 mt-4">
                <button
                  onClick={() => handleAccept(c.id)}
                  className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                >
                  Accept
                </button>
                <button
                  onClick={() => handleDeny(c.id)}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Deny
                </button>
                <button
                  onClick={() => handleMarkPaid(c.id)}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Mark Paid
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AllClients;
